module.exports = __webpack_public_path__ + "static/media/header-light.f6d50bc7.svg";